"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clausulas = void 0;
exports.clausulas = {
    FOB: { nombre: "FOB (Franco a borde)", sigla: "FOB" },
    CIF: { nombre: "CIF (Coste, seguro y flete)", sigla: "CIF" },
    EXW: { nombre: "EXW (En fábrica)", sigla: "EXW" },
    CIP: {
        nombre: "CIP (Transporte y seguro pagos hasta lugar de destino convenidos)",
        sigla: "CIP"
    },
    DAF: { nombre: "DAF (Entrega en frontera)", sigla: "DAF" },
    DES: { nombre: "DES (Entrega sobre buque)", sigla: "DES" },
    FCA: { nombre: "FCA (Free Carrier)", sigla: "FCA" },
    CFR: { nombre: "CFR (Cost and freight)", sigla: "CFR" },
    CPT: { nombre: "CPT (Carriage paid to)", sigla: "CPT" },
    DDP: { nombre: "DDP (Delivery duty paid)", sigla: "DDP" },
    DAP: { nombre: "DAP (Delivered at place)", sigla: "DAP" },
    NULL: { nombre: "N/A", sigla: "N/A" }
};
